import { render, staticRenderFns } from "./centerTop.vue?vue&type=template&id=55e03f0a&scoped=true"
import script from "./centerTop.vue?vue&type=script&lang=js"
export * from "./centerTop.vue?vue&type=script&lang=js"
import style0 from "./centerTop.vue?vue&type=style&index=0&id=55e03f0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e03f0a",
  null
  
)

export default component.exports